import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('WebReputation');
export const actions = helper.createActions('WebReputation', actionTypes);